import { Component } from '@angular/core';
import {
  FieldArrayType,
  FieldTypeConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface RepeaterFieldProps extends FormlyFieldProps {
  addText?: string;
  removeText?: string;
  addClick?: any;
  editable?: boolean;
  noDivider?: boolean;
}

@Component({
  selector: 'repeater-field',
  standalone: true,
  imports: [...FORM_IMPORTS, ButtonModule, DividerModule],
  template: `
    <div class="flex flex-col gap-2 w-full">
      @if (props.label) {
        <legend>{{ props.label }}</legend>
      }
      @if (props.description) {
        <p>{{ props.description }}</p>
      }

      @for (
        field of field.fieldGroup;
        track field;
        let i = $index;
        let last = $last
      ) {
        <div class="flex flex-col w-full gap-4">
          <formly-field [field]="field"></formly-field>
          @if (props.editable ?? true) {
            <p-button
              type="button"
              size="small"
              severity="danger"
              class="self-end"
              [variant]="'outlined'"
              (click)="remove(i)"
            >
              {{ props.removeText }}
            </p-button>
          }
        </div>
        @if (!last && !props.noDivider) {
          <p-divider />
        }
      }

      @if (props.editable ?? true) {
        <p-button
          type="button"
          size="small"
          variant="outlined"
          severity="secondary"
          class="self-start mt-4"
          (click)="callback()"
        >
          {{ props.addText }}
        </p-button>
      }

      <p-divider />
    </div>
  `,
})
export class RepeaterFieldType extends FieldArrayType<
  FieldTypeConfig<RepeaterFieldProps>
> {
  callback() {
    if (this.props.addClick) {
      this.props.addClick(this);
    } else {
      this.add(this.formControl.value.length, []);
    }
    setTimeout(() => {});
  }
}
